import React, { Component } from "react"
import { searchTableFilter, SumTable } from "../Tree/Utils.js"
import { payPeriod, womanManBoth, incomeType } from '../../variables/ComboValues'

import SearchBar from '../Tree/components/SearchBar.jsx'
//import { EditableCell } from '../TableList/EditableCell'
import { ProductRow } from '../TableList/ProductRow'
// input (props) 
//      tableTitle={"תוכנית עבודה"}
//      familyCode - TBD
// Resources: see import above

// TODO: get data from DB && Update to DB

export const  Income_microLegend = { 
  income_type: "סוג הכנסה",
  income_goesto: "המוטב",
  income_provider: "גורם משלם",
  income_frequency: "תדירות",
  income_sum: "סכום",
  income_comment: "הערה"
}

export class FamilyIncome extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      this.onSaveTable = this.onSaveTable.bind(this)
    }
    
    handleRowDel(product) {
      const {products} = this.state
      var index = products.indexOf(product)
      if (index === -1)
        return console.log("FamilyRights productnot found", product)

      var array = [...products]
      //this.state.products.splice(index, 1)
      array.splice(index, 1)
      this.setState({products:array})
    }
    /*
    handleRowDel(product) {
      var index = this.state.products.indexOf(product)
      this.state.products.splice(index, 1)
      this.setState(this.state.products)
    }*/
  
    handleAddEvent(evt) {
      evt.preventDefault()
      var id = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36);
      //let d = digmaDate(Date())
      var product = {
        id: id,
        income_type: "",
        income_goesto: "",
        income_provider: "",
        income_sum: "",
        income_frequency: "",
        income_comment: ""
      }
      let newp = ""
      if (this.state.products === undefined || this.state.products === false ){
        newp = [product]
      } else {
        newp = Object.assign(this.state.products)
        newp.unshift(product)
      }
      this.setState({products:newp})
      //this.state.products.unshift(product)
      //this.setState(this.state.products)
    }
  
    handleProductTable(evt) {
      evt.preventDefault()

      var item = {
        //id: evt.target.id,
        name: evt.target.name,
        value: evt.target.value,
        nid: evt.target.getAttribute('data-id')
    }
        // console.log("pRODUCT-EVT", item);

        var products = this.state.products.slice();
        // console.log("products-EVT", products);

        var newProducts = products.map(function(product) {
  
            for (var key in product) {
                if (key === item.name && product.id === item.nid) {
                    product[key] = item.value
                }
            }
            return product
        })
        this.setState({products:newProducts})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      //console.log("Family General save table: products", this.state.products)
   
      save2DB(familyPostId, this.state.products, subTableId, "table", inUpdate, mbouser )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      // console.log("Family general data", data)
      //console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable.bind(this)}
            onSaveTable={this.onSaveTable} 
            headerColumns = {["income_type", "income_goesto", "income_provider","income_sum","income_frequency", "income_comment"]}
            tableTitle = {tableTitle} // "סיכומי מפגשים"
            onRowAdd={this.handleAddEvent.bind(this)} 
            onRowDel={this.handleRowDel.bind(this)} 
            products={this.state.products} 
          />
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    /*
    calcIncomeSum(products){
      let i = 0, sum=0
      for (i =0; i < products.length; i++)
        sum += parseInt(products[i]['income_sum'])
      return sum
    }*/
    render() {
      const { onProductTableUpdate, onRowDel, onRowAdd, headerColumns, products, tableTitle, onSaveTable } = this.props
      var filterText = this.state.filterText;
      var thStyle = { fontSize: '15px',color:'#333', fontWeight: 'bold'}
      var buttonStyle = {marginRight: '0'}
      var searchbarStyle = {margin: '5px 10px'}
      var product = (typeof products === "undefined"  || products === false) ? null : products.map(function(product) {
          // check on all relevant data fields
          if (!searchTableFilter(product, filterText))
                return null;

        const cellData=[{ 
            type: "select",
            options: incomeType, // ["משכורת","הכנסה מעסק","סיוע בשכ''ד","קצבת ילדים","קצבת ילד נכה","מזונות","אבטלה","נכות","השלמת הכנסה","הבטחת הכנסה",
              // "קצבת שארים","הכנסות מהון","תמיכה משפחה/חברים","מענק קרן הצדקה","אחר"],
            name: "income_type",
            value: product.income_type,
            id: product.id,
            style: {width: "180px"},
            edit: true
          },{ 
          type: "select",
          options: womanManBoth, // ["האשה", "הגבר", "שני בני הזוג"],
          name: "income_goesto",
          value: product.income_goesto,
          id: product.id,
          style: {width: "100px"},
          edit: true
        },{
            type: "text",
            name: "income_provider",
            value: product.income_provider,
            id: product.id,
            style: {width: "180px"},
            edit: true
          },{
            type: "text",
            name: "income_sum",
            value: product.income_sum,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "select",
            options: payPeriod, // ["חודשי", "רבעוני", "שנתי", "חד פעמי", "אחר"],
            name: "income_frequency",
            value: product.income_frequency,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "textarea",
            name: "income_comment",
            value: product.income_comment,
            id: product.id,
            style: {width: "200px"},
            edit: true
          }] 

          return (
          <ProductRow 
            onProductTableUpdate={onProductTableUpdate} 
            product={product} 
            onDelEvent={onRowDel.bind(this)} 
            key={product.id}
            cd={cellData}
            />)
      })

      return (
        <div className="yahav-modal">
            <h2>{tableTitle}&nbsp;(סה"כ&nbsp;{products === undefined ? 0 : products.length})</h2>
            <button style={buttonStyle} type="button" onClick={onRowAdd} className="btn btn-success pull-right">הוספת שורה</button>
            <button style={buttonStyle} type="button"  className="btn btn-success pull-left" onClick={onSaveTable}>עדכון</button>
            <SearchBar style={searchbarStyle} filterText={this.state.filterText} onUserInput={this.handleUserInput.bind(this)} />
            <SumTable products={products} field={'income_sum'} frequency={'income_frequency'} title={'סה"כ הכנסות'} />
            {/*<span className="table-total">סה"כ הכנסות <span className="table-sum">{this.calcIncomeSum(products)}</span></span>
      console.table("Incomre table=", products)*/}
            <table className="table ">
                <thead>
                    <tr >
                    {headerColumns.map (col => { 
                      return(<th style={thStyle} key={col}>{Income_microLegend[col]?Income_microLegend[col] : col}</th>) 
                  }) } 
                    </tr>
                </thead>  
                <tbody>
                    {products === undefined ? null : product}
                </tbody>
            </table>
            <ul className="info-comments" style={{marginTop:'3em'}}>
              <li>מס הכנסה שלילי - מענק עבודה יש לחשב עבור כל הורה בנפרד. <a target="_blank" rel="noopener noreferrer" href="https://www.misim.gov.il/shmaanakavoda/frmFirst.aspx">מחשבון מענק עבודה</a>.</li>
            </ul>
        </div>
      )
    }
  }
 